import { FC } from 'react';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import './RecordDataItem.scss';

const cnBemRecordDataItem = createBemBlockBuilder(['recordDataItem']);

interface RecordDataItem {
  label: string;
}

export const RecordDataItem: FC<RecordDataItem> = ({
  children,
  label,
  ...props
}) => (
  <div className={cnBemRecordDataItem('__container')} {...props}>
    <span className={cnBemRecordDataItem('__label')}>{label} </span>
    {children}
  </div>
);
